@if(item && !hiddenForCompany && (!item.children || getFilteredChildren().length > 0)) {
<!-- Oculta si item es null o no tiene hijos visibles -->

@if(item.navCap) {
<div mat-subheader class="nav-caption">
  {{ item.navCap | translate }}
</div>
}

@if(!item.navCap && !item.external && !item.twoLines) {
<a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
        'mat-toolbar mat-primary activeMenu': item.route
          ? router.isActive(item.route, true)
          : false,
        expanded: expanded,
        disabled: item.disabled,
        'menu-locked': !!lockedBy
      }" class="menu-list-item" [attr.title]="lockTitle" [attr.aria-disabled]="lockedBy ? true : null">
  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <span class="hide-menu">{{ item.displayName | translate }}</span>
  @if (lockedBy) {
  <i-tabler class="menu-lock-icon hide-menu" name="lock" aria-hidden="true"></i-tabler>
  }

  @if(item.children && item.children.length) {
  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
  }

  @if(item.chip) {
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill">{{ item.chipContent }}</span>
  </span>
  }
</a>
}

<!-- Enlace Externo -->
@if(!item.navCap && item.external) {
<mat-list-item class="menu-list-item">
  <a [href]="item.route" target="_blank" rel="noopener noreferrer"
    style="display:flex;width:100%;text-decoration:none;color:inherit;">
    <i-tabler class="routeIcon" [name]="item.iconName" matListItemIcon>
    </i-tabler>

    <span class="hide-menu">
      {{ item.displayName | translate }}
    </span>
  </a>
</mat-list-item>
}

<!-- Submenú -->
@if(expanded && getFilteredChildren().length) {
@for(child of getFilteredChildren(); track child) {
<app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1">
</app-nav-item>
}
}

}